module.exports = __webpack_public_path__ + "static/media/robot.e57b800b.svg";